import React from 'react';
import {withTranslation} from 'react-i18next';
import _ from 'lodash';
import Table, {StripedTable} from '../../../shared/elements/table/TableFeature';
import {FormLabel} from '../../../shared/form/form-features/FormLabel';
import ExtraWorkEntry from './ExtraWorkEntry';

const ShowExtraWorkEntries = ({extraWorks, t, reloadMonth, ewiBeingEdited, onStartEdit, customer}) => {
    return (
        <StripedTable hover>
            <thead>
                <Table.Row>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.Date')}</FormLabel>
                    </Table.Header>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.ExtraWorkItem')}</FormLabel>
                    </Table.Header>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.Quantity')}</FormLabel>
                    </Table.Header>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.Unit')}</FormLabel>
                    </Table.Header>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.PricePerItem')}</FormLabel>
                    </Table.Header>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.TotalPrice')}</FormLabel>
                    </Table.Header>
                    <Table.Header>
                        <FormLabel>{t('customer.ExtraWorkEntries.Remark')}</FormLabel>
                    </Table.Header>
                    <Table.Header> </Table.Header>
                </Table.Row>
            </thead>
            <tbody>
                {_.isEmpty(extraWorks) && (
                    <Table.Row>
                        <Table.Data colSpan="999">{t('customer.NoExtraWorkFound')}</Table.Data>
                    </Table.Row>
                )}
                {!_.isEmpty(extraWorks) &&
                    _(extraWorks)
                        .orderBy('timestamp', 'asc')
                        .map((exw, index) => (
                            <ExtraWorkEntry
                                key={index}
                                exw={exw}
                                index={index}
                                reloadMonth={reloadMonth}
                                ewiBeingEdited={ewiBeingEdited}
                                onStartEdit={onStartEdit}
                                customer={customer}
                            />
                        ))
                        .value()}
            </tbody>
        </StripedTable>
    );
};

export default withTranslation()(ShowExtraWorkEntries);
